import { IConfigsType } from '../../types'

const burgerworksBenchmarkingProductMix: IConfigsType = {
  'burgerworks-benchmarking': {
    '/:brand/benchmarking_metrics': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'burgerworks/benchmarking_metrics',
        height: '1400px',
      },
    },
    '/:brand/benchmarking_product_mix': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'burgerworks/benchmarking_product_mix',
        height: '1400px',
      },
    },
    '/:brand/benchmarking_marketing_campaign': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'burgerworks/benchmarking_marketing_campaign',
        height: '1400px',
      },
    },
  },
}

export default burgerworksBenchmarkingProductMix
